import { SummaryViewResponseAPI } from '@/types/summaryView';

export const FETCH_ORG_SUMMARY_VIEW_SUCCESS = 'FETCH_ORG_SUMMARY_VIEW_SUCCESS';

export interface OrgSummaryViewResponse {
    requestId: string;
    scopeKey: string;
    rowSetSignature: string;
    fetchedProperties: string[];
    summaryView: SummaryViewResponseAPI;
}

export const createSummaryViewScopeKey = ({
    requestId,
    appToDestinationIds,
    versions,
    keywords,
    offset,
    limit,
}: {
    requestId: string;
    appToDestinationIds: Record<string, string[]>;
    versions?: string[];
    keywords?: string[];
    offset?: number;
    limit?: number;
}) =>
    JSON.stringify({
        requestId,
        appToDestinationIds,
        ...(versions ? { versions } : {}),
        ...(keywords?.length ? { keywords } : {}),
        offset: offset ?? 0,
        limit: limit ?? 0,
    });

export interface FetchOrgSummaryViewSuccessAction {
    type: typeof FETCH_ORG_SUMMARY_VIEW_SUCCESS;
    payload: OrgSummaryViewResponse;
}

export const fetchOrgSummaryViewSuccess: (payload: OrgSummaryViewResponse) => FetchOrgSummaryViewSuccessAction = (
    payload,
) => {
    return {
        type: FETCH_ORG_SUMMARY_VIEW_SUCCESS,
        payload,
    };
};
